import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("mc_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const viewTrip = localStorage.getItem("mc_view_trip");
  if (viewTrip) config.headers["X-Trip-Id"] = viewTrip;
  return config;
});

api.interceptors.response.use((r) => r, (e) => {
  if (e?.response?.status === 423) {
    import("sonner").then(({ toast }) => toast("This journey is archived and read-only.", { description: "Switch back to the current journey to post or edit.", id: "trip-readonly" }));
  }
  return Promise.reject(e);
});

export const VIEW_TRIP_KEY = "mc_view_trip";

export const fileUrl = (url, w) => {
  if (!url) return "";
  const isFile = url.includes("/api/files/");
  const base = url.startsWith("http") ? url : `${BACKEND_URL}${url}`;
  if (w && isFile) return `${base}${base.includes("?") ? "&" : "?"}w=${w}`;
  return base;
};

export const fmtMoney = (cents, currency = "USD") =>
  new Intl.NumberFormat("en-US", { style: "currency", currency, maximumFractionDigits: 0 }).format((cents || 0) / 100);

export const videoEmbed = (url) => {
  if (!url) return null;
  const yt = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{11})/);
  if (yt) return { type: "iframe", src: `https://www.youtube.com/embed/${yt[1]}` };
  const vimeo = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
  if (vimeo) return { type: "iframe", src: `https://player.vimeo.com/video/${vimeo[1]}` };
  if (/\.(mp4|webm|ogg|mov)(\?.*)?$/i.test(url)) return { type: "video", src: url };
  return { type: "link", src: url };
};

export const apiErr = (e) => {
  // Timeout / aborted request
  if (e?.code === "ECONNABORTED") return "This is taking longer than expected — check your connection and try again.";
  // No response at all = network / server unreachable / CORS
  if (e && !e.response) return "Can't reach the server right now. Please check your connection and try again.";
  const status = e?.response?.status;
  const d = e?.response?.data?.detail;
  if (typeof d === "string" && d.trim()) return d;
  if (Array.isArray(d) && d.length) return d.map((x) => x?.msg || "Please check your input").join(". ");
  if (status === 401) return "Your session has expired. Please sign in again.";
  if (status === 403) return "You don't have permission to do that.";
  if (status === 404) return "We couldn't find what you were looking for.";
  if (status === 413) return "That file is too large. Please choose a smaller one.";
  if (status === 429) return "Too many attempts. Please wait a moment and try again.";
  if (status >= 500) return "Something went wrong on our end. Please try again in a moment.";
  return e?.message || "Something went wrong. Please try again.";
};

export default api;
